export const DOCUMENT_UPLOAD_MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB
